import { Link } from 'react-router'
import { Compass } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export default function NoEncontrado() {
  return (
    <main className="flex min-h-dvh items-center justify-center bg-muted/40 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <Compass className="size-6 text-muted-foreground" aria-hidden="true" />
          <CardTitle>Esta página no existe</CardTitle>
          <CardDescription>Puede que el enlace esté mal escrito o que ya no esté.</CardDescription>
        </CardHeader>
        <CardContent>
          <Button render={<Link to="/" />}>Volver al inicio</Button>
        </CardContent>
      </Card>
    </main>
  )
}
